export const iconFontAwesomeShoppingCcVisa = (
	<i className="fa-solid fa-cc-visa"></i>
);
